<template>

  <v-container fluid>

    <!-- 접수양식 신규, 수정용 팝업 다이얼로그 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ formTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row>
                <v-textarea outlined v-model="editedItem.TITLE" :label="$t('eventformat_col1')"  :hint="$t('eventformat_label1')"></v-textarea>
              </v-row>
              <v-row class="mb-3">
                <v-textarea outlined v-model="editedItem.TITLE_ENG" :label="$t('eventformat_col8')"  :hint="$t('eventformat_label1')"></v-textarea>
              </v-row>
              <v-row>
                <v-select
                    outlined
                    v-model="editedItem.TYPE"
                    :items="optypelist"
                    :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'"
                    item-value="value"
                    :label="$t('eventformat_col3')"
                    ></v-select>
              </v-row>
              <v-row>
                <v-select
                    outlined
                    v-model="editedItem.STATE"
                    :items="opstatelist"
                    :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'"
                    item-value="value"
                    :label="$t('eventformat_col2')"
                    ></v-select>
              </v-row>
              <v-row>
                <v-select
                    outlined
                    v-model="editedItem.REQTYPE"
                    :items="REQLIST"
                    :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'"
                    item-value="value"
                    :label="$t('eventformat_col7')"
                    ></v-select>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="save">{{$t("common_save")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 접수양식상세 신규, 수정용 팝업 다이얼로그 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog2" @keydown.esc="close2" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('eventformat_label2')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close2"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row>
                <v-text-field outlined v-model="editedItem2.NAME" hide-details :label="$t('eventformat_col6')"></v-text-field>
              </v-row>  
              <v-row class="mt-3">
                <v-text-field outlined v-model="editedItem2.NAME_ENG" hide-details :label="$t('eventformat_col9')"></v-text-field>
              </v-row>  
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="close2">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="save2">{{$t("common_save")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row dense align="start">

    <v-col cols="12" md="7" sm="6" xs="6">
      
      <v-row align="center" justify="start" dense>
        <v-col cols="2" class="d-flex justify-center">
          <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
        </v-col>
        <v-col>
          <label style="color:red">{{$t('eventformat_label3')}}</label>
        </v-col>
      </v-row>
      
      <v-row align="center" justify="space-between">        
        <v-spacer/>
        <template v-if="grade >= 50">
          <v-col cols="12" md="3" sm="12" xs="12">
            <comdialog   :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
          </v-col>
        </template>
        <template v-else>
          <v-spacer/>
        </template>
        <v-col cols="12" md="3" sm="12" xs="12">
          <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
        </v-col>
        <v-col cols="12" md="4" sm="12" xs="12">
          <v-btn :data-my-variable="$i18n.locale === 'ko' ? 'true' : 'false'" class="blue_btn mr-1" elevation="0" outlined large @click="insertItem">{{$t('eventformat_label4')}}</v-btn>
          <v-btn :data-my-variable="$i18n.locale === 'ko' ? 'true' : 'false'" class="yellow_btn" elevation="0" outlined large @click="saveSort">{{$t('eventformat_label5')}}</v-btn>
        </v-col>
      </v-row>

      <draggable v-model="items">
        <v-data-table
            :headers="headers"
            :items="items"
            hide-default-footer
            :items-per-page="9999"
            :no-data-text="$t('eventformat_msg17')"
            :no-results-text="$t('eventformat_msg18')"
            class="datatablestyle ml-5 mr-5"
            item-key="name"
            :loading="loading"
            >
            <template v-slot:header.TITLE>
              <label class="cheader_normal" >{{$t("eventformat_col1")}}</label>
            </template>
            <template v-slot:header.STATE_NAME>
              <label class="cheader_normal" >{{$t("eventformat_col2")}}</label>
            </template>
            <template v-slot:header.TYPE_NAME>
              <label class="cheader_normal" >{{$t("eventformat_col3")}}</label>
            </template>
            <template v-slot:header.REQTYPE_NAME>
              <label class="cheader_normal" >{{$t("eventformat_col7")}}</label>
            </template>
            <template v-slot:header.detail>
              <label class="cheader_normal" >{{$t("eventformat_col4")}}</label>
            </template>
            <template v-slot:header.actions>
              <label class="cheader_normal" >{{$t("eventformat_col5")}}</label>
            </template>

          <template v-slot:body="props">
            <draggable :list="props.items" ghost-class="ghost" @change="changedrag" tag="tbody">
              <tr v-for="(item, index) in props.items" :key="index">
                <td style="width:50px; text-align:center"><v-icon small>mdi-drag</v-icon></td>
                <td style="width:250px; text-align:left">
                  <div style="white-space:pre-line;">{{ item.TITLE }}</div>
                  <div style="color:#800000;white-space:pre-line;">{{ item.TITLE_ENG }}</div>
                </td>
                <!-- 블루오리진 요청
                <template v-if="item.TYPE == 0">
                  <td style="width:100px; text-align:center">{{item.TYPE_NAME}}</td>
                </template>
                <template v-else>
                  <td style="width:100px; text-align:center"><a small @click="loaddetail(item)">{{item.TYPE_NAME}}</a></td>
                </template>
                -->
                <td style="width:100px; text-align:center">{{ item.STATE_NAME }}</td>
                <td style="width:100px; text-align:left">{{ item.TYPE_NAME }}</td>
                <td style="width:150px; text-align:left">{{ item.REQTYPE_NAME }}</td>

                <template v-if="item.TYPE == 0 || item.TYPE == 9">
                  <td style="width:100px; text-align:center"><a class="mr-2" small></a></td>
                </template>
                <template v-else>
                  <td style="width:100px; text-align:center"><a class="mr-2" small @click="loaddetail(item)">{{$t("common_insert")}}</a></td>
                </template>
                <td style="width:100px; text-align:center"><v-icon class="mr-2" small @click="editItem(item)">mdi-pencil</v-icon><v-icon small @click="deleteItem(item)">mdi-delete</v-icon></td>
              </tr>
            </draggable>
          </template>
        </v-data-table>
      </draggable>
      </v-col>


      <v-col v-if="PARENT_ITEM != null" cols="12" md="5" sm="6" xs="6">
      <v-row dense justify="center">
        <v-col cols="12">
          <label>{{$t('eventformat_label6')}}</label>
        </v-col>
      </v-row>  
      <v-row dense>
        <v-col cols="12" md="6" sm="6" xs="6">
          <label class="menunamestyle">{{ PARENT_ITEM.TITLE }}</label>
        </v-col>
        <v-col cols="12" md="6" sm="6" xs="6">
          <v-btn :data-my-variable="$i18n.locale === 'ko' ? 'true' : 'false'" class="blue_btn" elevation="0" outlined large @click="insertItem2()">{{$t('eventformat_label7')}}</v-btn>
          <v-btn :data-my-variable="$i18n.locale === 'ko' ? 'true' : 'false'" class="yellow_btn ml-1" elevation="0" outlined large @click="saveSort2()">{{$t('eventformat_label5')}}</v-btn>
        </v-col>
      </v-row>
      <v-data-table
          :headers="headers2"
          :items="items2"
          hide-default-footer
          :items-per-page="9999"
          :no-data-text="$t('eventformat_msg17')"
          :no-results-text="$t('eventformat_msg18')"
          class="datatablestyle ml-5 mr-5 mt-5"
          item-key="name"
          :loading="loading2"
          >
          <template v-slot:header.NAME>
            <label class="cheader_normal" >{{$t("eventformat_col6")}}</label>
          </template>
          <template v-slot:header.actions>
            <label class="cheader_normal" >{{$t("eventformat_col5")}}</label>
          </template>

          <template v-slot:body="props">
            <draggable :list="props.items" ghost-class="ghost" @change="changedrag2" tag="tbody">
              <tr v-for="(item, index) in props.items" :key="index">
                <td style="width:50px; text-align:center"><v-icon small>mdi-drag</v-icon></td>
                <td style="width:250px; text-align:left">
                  <div>{{ item.NAME }}</div>
                  <div style="color:#800000">{{ item.NAME_ENG }}</div>
                </td>
                <td style="width:100px; text-align:center"><v-icon class="mr-2" small @click="editItem2(item)">mdi-pencil</v-icon><v-icon small @click="deleteItem2(item)">mdi-delete</v-icon></td>
              </tr>
            </draggable>
          </template>
      </v-data-table>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
  import draggable from 'vuedraggable'
  
  export default {

    components: {
            draggable,
    },

    methods: {
      //오리지널 리스트 순서를 변경
      changedrag(e){
        this.items.splice(e.moved.oldIndex, 1);  //원본 위치에서 제거
        this.items.splice(e.moved.newIndex, 0, e.moved.element);  //새로운 위치에 다시 추가
      },

      changedrag2(e){
        this.items2.splice(e.moved.oldIndex, 1);  //원본 위치에서 제거
        this.items2.splice(e.moved.newIndex, 0, e.moved.element);  //새로운 위치에 다시 추가
      },

      saveSort(){

        if(this.items.length <= 1){
          this.$alert(this.$t('eventformat_msg1'));
          return;
        }

        //드래그앤드랍 순서를 저장한다.
        this.$confirm(this.$t('eventformat_msg2'))
        .then(() => {

          var tempidx = 0;
          this.items.forEach(item=>{
            item.SORT = tempidx;
            tempidx++;
          });

          this.loading = true;
          this.$http.post(this.$host+'/api/FormatUpdateSort',
            {
              SORTDATA: escape(JSON.stringify(this.items))
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('eventformat_msg3')).then(()=>{
                  this.loadpage();
                });
  

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t('common_sort_fail'));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t('common_sort_fail'));
          });
          

        });
      },


      saveSort2(){

        if(this.items2.length <= 1){
          this.$alert(this.$t('eventformat_msg4'));
          return;
        }

        if(this.PARENT_ITEM == null){
          this.$alert(this.$t('eventformat_msg4'));
          return;
        }

        //드래그앤드랍 순서를 저장한다.
        this.$confirm(this.$t('eventformat_msg5'))
        .then(() => {

          var tempidx = 0;
          this.items2.forEach(item=>{
            item.SORT = tempidx;
            tempidx++;
          });

          this.loading2 = true;
          this.$http.post(this.$host+'/api/FormatOptionUpdateSort',
            {
              SORTDATA: escape(JSON.stringify(this.items2))
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            this.loading2 = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('eventformat_msg6')).then(()=>{
                  this.loaddetail(this.PARENT_ITEM);
                });
  
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t('eventformat_msg7'));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t('eventformat_msg7'));
          });
          

        });
      },      

      //리스트 아이템 추가
      insertItem(){
        
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        this.editedIndex  = -1;
        this.editedItem   = Object.assign({}, this.defaultItem);
        if(this.items != null && this.items.length > 0){
          this.editedItem.SORT = this.items.length;
        }
        this.dialog       = true

      },

      editItem (item) {
        //아이템 수정
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        
        this.$confirm(this.$t('eventformat_msg8'))
        .then(() => {

          this.loading = true;
          this.$http.post(this.$host+'/api/FormatDelete',
            {
                IDX: item.IDX
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: item.EVENT_IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                this.loadpage();
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_fail"));
          });      

        });
      },

      close () {
        //팝업닫기
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {

        
        if(this.editedItem.TITLE.length < 1){
          this.$alert(this.$t('eventformat_msg9'));
          return;
        }


        //팝업 저장
        if (this.editedIndex > -1) {
          
          this.loading = true;
          this.$http.post(this.$host+'/api/FormatUpdate',
            {
                IDX: this.editedItem.IDX
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.editedItem.EVENT_IDX
              , TITLE : this.editedItem.TITLE
              , TITLE_ENG : this.editedItem.TITLE_ENG == null || this.editedItem.TITLE_ENG == undefined ? '' : this.editedItem.TITLE_ENG
              , TYPE : this.editedItem.TYPE
              , STATE : this.editedItem.STATE
              , SORT : this.editedItem.SORT
              , REQTYPE : this.editedItem.REQTYPE
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  this.loadpage();
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_edit_fail"));
          });


        } else {

          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/FormatInsert',
            {
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , TITLE : escape(this.editedItem.TITLE)
              , TITLE_ENG : this.editedItem.TITLE_ENG == null || this.editedItem.TITLE_ENG == undefined ? '' : escape(this.editedItem.TITLE_ENG)
              , TYPE : this.editedItem.TYPE
              , STATE : this.editedItem.STATE
              , SORT : this.editedItem.SORT
              , REQTYPE : this.editedItem.REQTYPE
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

                //인설트 성공하면 페이지 갱신
                this.$alert(this.$t('common_insert_msg')).then(()=>{
                  this.loadpage();
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동


            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
          });
        }
        this.close()
      },

      loadpage(){

        this.items.splice(0, this.items.length);   //데이터 초기화

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

          this.loading = true;
          this.$http.post(this.$host+'/api/FormatList',
            {
                ADMIN_IDX : this.$session.get("ADMIN_IDX")
              , COM_IDX : this.SEARCH_COM_IDX
              , EVENT_IDX : this.SEARCH_EVENT_IDX
              , LAN_CODE:this.$i18n.locale
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              const list = result.data.resultData;
              
              list.forEach(element => {
                  this.items.push(element); 
              });

              this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
          //첫페이지 로드
          this.loadpage();
      },



      loaddetail(item){
          
          this.PARENT_ITEM = item;

          this.loading2 = true;
          this.$http.post(this.$host+'/api/FormatOptionList',
            {
                ADMIN_IDX : this.$session.get("ADMIN_IDX")
              , FORMAT_IDX : item.IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              const list = result.data.resultData;
              this.items2.splice(0, this.items2.length);   //데이터 초기화
              list.forEach(element => {
                  this.items2.push(element); 
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동


            }
            this.loading2 = false;
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading2 = false;
          });

      },

      //리스트 아이템 추가
      insertItem2(){
        
        if(this.PARENT_ITEM.IDX == null || this.PARENT_ITEM.IDX == undefined){
          this.$alert(this.$t('eventformat_msg10'));
          return;
        }

        this.editedIndex2  = -1;
        this.editedItem2   = Object.assign({}, this.defaultItem2);
        if(this.items2 != null && this.items2.length > 0){
          this.editedItem2.SORT = this.items2.length;
        }
        this.dialog2       = true;
      },

      editItem2 (item) {
        //아이템 수정
        this.editedIndex2 = this.items2.indexOf(item)
        this.editedItem2 = Object.assign({}, item)
        this.dialog2 = true
      },

      deleteItem2 (item) {
        
        this.$confirm(this.$t('eventformat_msg11'))
        .then(() => {

          this.loading2 = true;
          this.$http.post(this.$host+'/api/FormatOptionDelete',
            {
                IDX : item.IDX
              , ADMIN_IDX: item.ADMIN_IDX
              , FORMAT_IDX: item.FORMAT_IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading2 = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.$alert(this.$t("common_delete_com")).then(()=>{
                //갱신필요
                this.loaddetail(this.PARENT_ITEM);
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading2 = false;
              this.$alert(this.$t("common_delete_fail"));
          });      

        });
      },

      close2 () {
        //팝업닫기
        this.dialog2 = false
        setTimeout(() => {
          this.editedItem2 = Object.assign({}, this.defaultItem2)
          this.editedIndex2 = -1
        }, 300)
      },

      save2 () {

        if(this.editedItem2.NAME  == undefined || this.editedItem2.NAME.length < 1){
          this.$alert(this.$t('eventformat_msg12'));
          return;
        } 

        //팝업 저장
        if (this.editedIndex2 > -1) {
          
          
          this.loading2 = true;
          this.$http.post(this.$host+'/api/FormatOptionUpdate',
            {
                IDX : this.editedItem2.IDX
              , ADMIN_IDX : this.editedItem2.ADMIN_IDX
              , FORMAT_IDX : this.PARENT_ITEM.IDX
              , NAME : escape(this.editedItem2.NAME)
              , NAME_ENG : this.editedItem2.NAME_ENG == null || this.editedItem2.NAME_ENG == undefined ? '' : escape(this.editedItem2.NAME_ENG)
              , SORT : this.editedItem2.SORT
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading2 = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.$alert(this.$t('eventformat_msg13')).then(()=>{
                //여기서 갱신한번 해줘야 한다.
                this.loaddetail(this.PARENT_ITEM);
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading2 = false;
              this.$alert(this.$t("common_edit_fail"));
          });


        } else {

          //신규
          this.loading2 = true;
          this.$http.post(this.$host+'/api/FormatOptionInsert',
            {
                ADMIN_IDX : this.$session.get("ADMIN_IDX")
              , FORMAT_IDX : this.PARENT_ITEM.IDX
              , NAME : escape(this.editedItem2.NAME)
              , NAME_ENG : this.editedItem2.NAME_ENG == null || this.editedItem2.NAME_ENG == undefined ? '' : escape(this.editedItem2.NAME_ENG)
              , SORT : this.editedItem2.SORT
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading2 = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.$alert(this.$t('eventformat_msg14')).then(()=>{
                //페이지 갱신 필요
                this.loaddetail(this.PARENT_ITEM);
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading2 = false;
          });
        }
        this.close2()
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        
        this.PARENT_ITEM = null;
        this.loadpage();
        
      },


      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        
        this.items.splice(0, this.items.length);   //데이터 초기화
        this.PARENT_ITEM = null;

      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          
          this.items.splice(0, this.items.length);   //데이터 초기화
          this.PARENT_ITEM = null;

      },



    },

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인 해야해
        this.$router.push("Login");
      }
    },

    computed: {
      formTitle () {
        //수정 팝업 제목의 신규와 수정을 구분하기 위함
        return this.editedIndex === -1 ? this.$t('eventformat_msg15') : this.$t('eventformat_msg16')
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    data () {
      return {

        loading : false,    //로딩 표시
        loading2 : false,   //로딩 표시
        
        //pagination: {},     //페이징 정보가 들어가는 듯. 알아서 들어감. 

        editedIndex: -1,
        editedIndex2: -1,

        dialog : false,
        dialog2 : false,

        optypelist: [
            {name:'단일선택', name2:"Single Choice", value:1}
          , {name:'다중선택', name2:"Multi Choice", value:2}
          , {name:'주관식', name2:"Input", value:0}
          , {name:'없음', name2:"None", value:9}
        ],
        opstatelist: [
            {name:'사용안함', name2:"Not Used", value:0}
          , {name:'사용',  name2:"Used", value:1}
        ],
        REQLIST: [
            {name:'선택입력', name2:"Selected",  value:0}
          , {name:'필수입력', name2:"Required",  value:1}
        ],
        headers: [
          {text: '', align: 'center', sortable: false, value: '', width:'50px'},
          {text: '질문내용', align: 'center', sortable: false, value: 'TITLE', width:'250px'},
          {text: '질문사용여부', align: 'center', sortable: false, value: 'STATE_NAME',width:'100px'},
          {text: '답변타입', align: 'center', sortable: false, value: 'TYPE_NAME',width:'100px'},
          {text: '답변필수여부', align: 'center', sortable: false, value: 'REQTYPE_NAME',width:'100px'},
          {text: '세부항목', align: 'center', sortable: false, value: 'detail',width:'100px'},
          {text: '수정/삭제', align:'center', sortable:false, value: 'actions',width:'100px' }
        ],
        items: [],
        defaultItem: {
            IDX:null,
            TITLE:'',
            TITLE_ENG:'',
            TYPE:0,
            STATE:1,
            SORT:1,
            REQTYPE:1
        },
        editedItem: {},
        
        PARENT_ITEM: {},
        headers2: [
          {text: '', align: 'center', sortable: false, value: '', width:'50px'},
          {text: '답변항목', align: 'left', sortable: false, value: 'NAME', width:'250px'},
          {text: '수정/삭제', align:'center', sortable:false, value: 'actions', width:'100px' }
        ],
        items2: [],
        editedItem2: {},        
        defaultItem2: {
            NAME:'',
            NAME_ENG:'',
            SORT:1,
        },

        SEARCH_COM_IDX: null,
        SEARCH_COM_NAME: '',
        SEARCH_EVENT_IDX: null,
        SEARCH_EVENT_NAME: '',
        grade : 0,
        
      }
    }
  }
</script>
<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>  
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }

  li {
    display: inline;
  }

  .pagination{
    margin: 0px;
  }


</style>
